import { ValidationError } from "@mixitone/oom";

export const DOCUMENT_UPLOAD_FAILED_MESSAGE =
  "The file did not upload, so this document was not saved. Choose the PDF and try again.";

interface DocumentPendingFile {
  document_id?: string | null;
  persisted: boolean;
  destroy: () => Promise<unknown>;
  save: () => Promise<unknown>;
}

export function clubDocumentUploadError(error: unknown): string {
  if (error instanceof Error && error.message === "Unsupported file type") {
    return "Choose a PDF. This document was not saved.";
  }
  if (error instanceof Error && error.message === "Not signed in") {
    return "Sign in again, then choose the PDF. This document was not saved.";
  }
  return DOCUMENT_UPLOAD_FAILED_MESSAGE;
}

/**
 * Saves a club document only after its file is stored.
 * A row created earlier is deleted when the upload did not produce a file id.
 */
export async function saveClubDocumentWithFile(record: DocumentPendingFile): Promise<void> {
  if (!record.document_id) {
    if (record.persisted) await record.destroy();
    throw new ValidationError({ document_id: DOCUMENT_UPLOAD_FAILED_MESSAGE });
  }
  await record.save();
}
